/* tslint:disable */
/* eslint-disable */
/**
 * BFF for Portal API
 * Backend for Frontend - Autentizace a proxy pro Pecosta portál
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdminInvitationRequest
 */
export interface AdminInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminInvitationRequest
     */
    'login': string;
}
/**
 * 
 * @export
 * @interface AdminInvitationResponse
 */
export interface AdminInvitationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminInvitationResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminInvitationResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminSessionDto
 */
export interface AdminSessionDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'sessionId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionDto
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'lastAccessedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionDto
     */
    'userAgent'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSessionDto
     */
    'rememberMe': boolean;
}
/**
 * 
 * @export
 * @interface AdminSessionListResponse
 */
export interface AdminSessionListResponse {
    /**
     * 
     * @type {Array<AdminSessionDto>}
     * @memberof AdminSessionListResponse
     */
    'sessions': Array<AdminSessionDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionListResponse
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface AdminSetPasswordRequest
 */
export interface AdminSetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSetPasswordRequest
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSetPasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface AdminSetPasswordResponse
 */
export interface AdminSetPasswordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminSetPasswordResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSetPasswordResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordResponse
 */
export interface ChangePasswordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ChangePasswordResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DemoInvitationAcceptRequest
 */
export interface DemoInvitationAcceptRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptRequest
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptRequest
     */
    'confirmPassword'?: string;
}
/**
 * 
 * @export
 * @interface DemoInvitationAcceptResponse
 */
export interface DemoInvitationAcceptResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DemoInvitationAcceptResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptResponse
     */
    'login'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DemoInvitationAcceptResponse
     */
    'loggedIn': boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationAcceptResponse
     */
    'sessionId'?: string;
}
/**
 * 
 * @export
 * @interface DemoInvitationPreviewResponse
 */
export interface DemoInvitationPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'status': DemoInvitationPreviewResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'mode': DemoInvitationPreviewResponseModeEnum;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationPreviewResponse
     */
    'login'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DemoInvitationPreviewResponse
     */
    'canRenew': boolean;
    /**
     * 
     * @type {number}
     * @memberof DemoInvitationPreviewResponse
     */
    'passwordMinLength'?: number;
}

export const DemoInvitationPreviewResponseStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type DemoInvitationPreviewResponseStatusEnum = typeof DemoInvitationPreviewResponseStatusEnum[keyof typeof DemoInvitationPreviewResponseStatusEnum];
export const DemoInvitationPreviewResponseModeEnum = {
    NewUser: 'NEW_USER',
    ExistingUser: 'EXISTING_USER'
} as const;

export type DemoInvitationPreviewResponseModeEnum = typeof DemoInvitationPreviewResponseModeEnum[keyof typeof DemoInvitationPreviewResponseModeEnum];

/**
 * 
 * @export
 * @interface DemoInvitationSimpleResponse
 */
export interface DemoInvitationSimpleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DemoInvitationSimpleResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationSimpleResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ForgotLoginRequest
 */
export interface ForgotLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotLoginRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ForgotLoginResponse
 */
export interface ForgotLoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ForgotLoginResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForgotLoginResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'login': string;
}
/**
 * 
 * @export
 * @interface ForgotPasswordResponse
 */
export interface ForgotPasswordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ForgotPasswordResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ImpersonationLinkResponse
 */
export interface ImpersonationLinkResponse {
    /**
     * 
     * @type {number}
     * @memberof ImpersonationLinkResponse
     */
    'targetUserId': number;
    /**
     * 
     * @type {string}
     * @memberof ImpersonationLinkResponse
     */
    'targetEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImpersonationLinkResponse
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof ImpersonationLinkResponse
     */
    'expiresInSeconds': number;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRequest
     */
    'rememberMe': boolean;
}
/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'message'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof LoginResponse
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'sessionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'rememberMe'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'forcePasswordChange': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationDto
 */
export interface OrganizationDto {
    /**
     * 
     * @type {number}
     * @memberof OrganizationDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDto
     */
    'dic'?: string;
    /**
     * 
     * @type {Array<PortalInfoDto>}
     * @memberof OrganizationDto
     */
    'portals': Array<PortalInfoDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationDto
     */
    'features': Array<string>;
}
/**
 * 
 * @export
 * @interface PortalInfoDto
 */
export interface PortalInfoDto {
    /**
     * 
     * @type {number}
     * @memberof PortalInfoDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PortalInfoDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortalInfoDto
     */
    'shortcut': string;
    /**
     * 
     * @type {boolean}
     * @memberof PortalInfoDto
     */
    'isClient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalInfoDto
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortalInfoDto
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'confirmPassword': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'nickname'?: string;
}
/**
 * 
 * @export
 * @interface RegisterResponse
 */
export interface RegisterResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RegisterResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'message'?: string;
    /**
     * 
     * @type {UserDto}
     * @memberof RegisterResponse
     */
    'user'?: UserDto;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordResponse
 */
export interface ResetPasswordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResetPasswordResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {Array<OrganizationDto>}
     * @memberof UserDto
     */
    'organizations'?: Array<OrganizationDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'impersonatedBy'?: number;
}

/**
 * AdminSessionsApi - axios parameter creator
 * @export
 */
export const AdminSessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Force logout a specific session
         * @param {string} targetSessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSession: async (targetSessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetSessionId' is not null or undefined
            assertParamExists('deleteAdminSession', 'targetSessionId', targetSessionId)
            const localVarPath = `/api/admin/sessions/{targetSessionId}`
                .replace(`{${"targetSessionId"}}`, encodeURIComponent(String(targetSessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Force logout all sessions of a user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserSessions: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminUserSessions', 'userId', userId)
            const localVarPath = `/api/admin/sessions/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all active sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSessionList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSessionsApi - functional programming interface
 * @export
 */
export const AdminSessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Force logout a specific session
         * @param {string} targetSessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminSession(targetSessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminSession(targetSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSessionsApi.deleteAdminSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Force logout all sessions of a user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminUserSessions(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminUserSessions(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSessionsApi.deleteAdminUserSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all active sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSessionList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSessionList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSessionsApi.getAdminSessionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSessionsApi - factory interface
 * @export
 */
export const AdminSessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSessionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Force logout a specific session
         * @param {AdminSessionsApiDeleteAdminSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSession(requestParameters: AdminSessionsApiDeleteAdminSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.deleteAdminSession(requestParameters.targetSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Force logout all sessions of a user
         * @param {AdminSessionsApiDeleteAdminUserSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserSessions(requestParameters: AdminSessionsApiDeleteAdminUserSessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.deleteAdminUserSessions(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all active sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSessionList(options?: RawAxiosRequestConfig): AxiosPromise<AdminSessionListResponse> {
            return localVarFp.getAdminSessionList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSessionsApi - interface
 * @export
 * @interface AdminSessionsApi
 */
export interface AdminSessionsApiInterface {
    /**
     * 
     * @summary Force logout a specific session
     * @param {AdminSessionsApiDeleteAdminSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApiInterface
     */
    deleteAdminSession(requestParameters: AdminSessionsApiDeleteAdminSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @summary Force logout all sessions of a user
     * @param {AdminSessionsApiDeleteAdminUserSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApiInterface
     */
    deleteAdminUserSessions(requestParameters: AdminSessionsApiDeleteAdminUserSessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @summary Get all active sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApiInterface
     */
    getAdminSessionList(options?: RawAxiosRequestConfig): AxiosPromise<AdminSessionListResponse>;

}

/**
 * Request parameters for deleteAdminSession operation in AdminSessionsApi.
 * @export
 * @interface AdminSessionsApiDeleteAdminSessionRequest
 */
export interface AdminSessionsApiDeleteAdminSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionsApiDeleteAdminSession
     */
    readonly targetSessionId: string
}

/**
 * Request parameters for deleteAdminUserSessions operation in AdminSessionsApi.
 * @export
 * @interface AdminSessionsApiDeleteAdminUserSessionsRequest
 */
export interface AdminSessionsApiDeleteAdminUserSessionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSessionsApiDeleteAdminUserSessions
     */
    readonly userId: number
}

/**
 * AdminSessionsApi - object-oriented interface
 * @export
 * @class AdminSessionsApi
 * @extends {BaseAPI}
 */
export class AdminSessionsApi extends BaseAPI implements AdminSessionsApiInterface {
    /**
     * 
     * @summary Force logout a specific session
     * @param {AdminSessionsApiDeleteAdminSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public deleteAdminSession(requestParameters: AdminSessionsApiDeleteAdminSessionRequest, options?: RawAxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).deleteAdminSession(requestParameters.targetSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Force logout all sessions of a user
     * @param {AdminSessionsApiDeleteAdminUserSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public deleteAdminUserSessions(requestParameters: AdminSessionsApiDeleteAdminUserSessionsRequest, options?: RawAxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).deleteAdminUserSessions(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all active sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public getAdminSessionList(options?: RawAxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).getAdminSessionList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set password directly (admin, no token, no email)
         * @param {AdminSetPasswordRequest} adminSetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSetPassword: async (adminSetPasswordRequest: AdminSetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSetPasswordRequest' is not null or undefined
            assertParamExists('adminSetPassword', 'adminSetPasswordRequest', adminSetPasswordRequest)
            const localVarPath = `/api/auth/admin/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change password for logged in user
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/api/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send login names registered to an e-mail address
         * @param {ForgotLoginRequest} forgotLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotLogin: async (forgotLoginRequest: ForgotLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotLoginRequest' is not null or undefined
            assertParamExists('forgotLogin', 'forgotLoginRequest', forgotLoginRequest)
            const localVarPath = `/api/auth/forgot-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordRequest: ForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordRequest' is not null or undefined
            assertParamExists('forgotPassword', 'forgotPasswordRequest', forgotPasswordRequest)
            const localVarPath = `/api/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a new user
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerRequest: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('register', 'registerRequest', registerRequest)
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/api/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send an invitation e-mail with the login name and a password setup link (admin)
         * @param {AdminInvitationRequest} adminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitation: async (adminInvitationRequest: AdminInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminInvitationRequest' is not null or undefined
            assertParamExists('sendInvitation', 'adminInvitationRequest', adminInvitationRequest)
            const localVarPath = `/api/auth/admin/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set password directly (admin, no token, no email)
         * @param {AdminSetPasswordRequest} adminSetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSetPassword(adminSetPasswordRequest: AdminSetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSetPassword(adminSetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.adminSetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change password for logged in user
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send login names registered to an e-mail address
         * @param {ForgotLoginRequest} forgotLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotLogin(forgotLoginRequest: ForgotLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForgotLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotLogin(forgotLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.forgotLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForgotPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register a new user
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send an invitation e-mail with the login name and a password setup link (admin)
         * @param {AdminInvitationRequest} adminInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvitation(adminInvitationRequest: AdminInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvitation(adminInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.sendInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Set password directly (admin, no token, no email)
         * @param {AuthenticationApiAdminSetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSetPassword(requestParameters: AuthenticationApiAdminSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSetPasswordResponse> {
            return localVarFp.adminSetPassword(requestParameters.adminSetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change password for logged in user
         * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangePasswordResponse> {
            return localVarFp.changePassword(requestParameters.changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send login names registered to an e-mail address
         * @param {AuthenticationApiForgotLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotLogin(requestParameters: AuthenticationApiForgotLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotLoginResponse> {
            return localVarFp.forgotLogin(requestParameters.forgotLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request password reset
         * @param {AuthenticationApiForgotPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(requestParameters: AuthenticationApiForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotPasswordResponse> {
            return localVarFp.forgotPassword(requestParameters.forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login user
         * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.login(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new user
         * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponse> {
            return localVarFp.register(requestParameters.registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password with token
         * @param {AuthenticationApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestParameters: AuthenticationApiResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponse> {
            return localVarFp.resetPassword(requestParameters.resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send an invitation e-mail with the login name and a password setup link (admin)
         * @param {AuthenticationApiSendInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitation(requestParameters: AuthenticationApiSendInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvitationResponse> {
            return localVarFp.sendInvitation(requestParameters.adminInvitationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
    /**
     * 
     * @summary Set password directly (admin, no token, no email)
     * @param {AuthenticationApiAdminSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    adminSetPassword(requestParameters: AuthenticationApiAdminSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSetPasswordResponse>;

    /**
     * 
     * @summary Change password for logged in user
     * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangePasswordResponse>;

    /**
     * 
     * @summary Send login names registered to an e-mail address
     * @param {AuthenticationApiForgotLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    forgotLogin(requestParameters: AuthenticationApiForgotLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotLoginResponse>;

    /**
     * 
     * @summary Request password reset
     * @param {AuthenticationApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    forgotPassword(requestParameters: AuthenticationApiForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForgotPasswordResponse>;

    /**
     * 
     * @summary Get current user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserDto>;

    /**
     * 
     * @summary Login user
     * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse>;

    /**
     * 
     * @summary Logout user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    logout(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @summary Register a new user
     * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponse>;

    /**
     * 
     * @summary Reset password with token
     * @param {AuthenticationApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    resetPassword(requestParameters: AuthenticationApiResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponse>;

    /**
     * 
     * @summary Send an invitation e-mail with the login name and a password setup link (admin)
     * @param {AuthenticationApiSendInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    sendInvitation(requestParameters: AuthenticationApiSendInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvitationResponse>;

}

/**
 * Request parameters for adminSetPassword operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiAdminSetPasswordRequest
 */
export interface AuthenticationApiAdminSetPasswordRequest {
    /**
     * 
     * @type {AdminSetPasswordRequest}
     * @memberof AuthenticationApiAdminSetPassword
     */
    readonly adminSetPasswordRequest: AdminSetPasswordRequest
}

/**
 * Request parameters for changePassword operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiChangePasswordRequest
 */
export interface AuthenticationApiChangePasswordRequest {
    /**
     * 
     * @type {ChangePasswordRequest}
     * @memberof AuthenticationApiChangePassword
     */
    readonly changePasswordRequest: ChangePasswordRequest
}

/**
 * Request parameters for forgotLogin operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiForgotLoginRequest
 */
export interface AuthenticationApiForgotLoginRequest {
    /**
     * 
     * @type {ForgotLoginRequest}
     * @memberof AuthenticationApiForgotLogin
     */
    readonly forgotLoginRequest: ForgotLoginRequest
}

/**
 * Request parameters for forgotPassword operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiForgotPasswordRequest
 */
export interface AuthenticationApiForgotPasswordRequest {
    /**
     * 
     * @type {ForgotPasswordRequest}
     * @memberof AuthenticationApiForgotPassword
     */
    readonly forgotPasswordRequest: ForgotPasswordRequest
}

/**
 * Request parameters for login operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiLoginRequest
 */
export interface AuthenticationApiLoginRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof AuthenticationApiLogin
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for register operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiRegisterRequest
 */
export interface AuthenticationApiRegisterRequest {
    /**
     * 
     * @type {RegisterRequest}
     * @memberof AuthenticationApiRegister
     */
    readonly registerRequest: RegisterRequest
}

/**
 * Request parameters for resetPassword operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiResetPasswordRequest
 */
export interface AuthenticationApiResetPasswordRequest {
    /**
     * 
     * @type {ResetPasswordRequest}
     * @memberof AuthenticationApiResetPassword
     */
    readonly resetPasswordRequest: ResetPasswordRequest
}

/**
 * Request parameters for sendInvitation operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiSendInvitationRequest
 */
export interface AuthenticationApiSendInvitationRequest {
    /**
     * 
     * @type {AdminInvitationRequest}
     * @memberof AuthenticationApiSendInvitation
     */
    readonly adminInvitationRequest: AdminInvitationRequest
}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI implements AuthenticationApiInterface {
    /**
     * 
     * @summary Set password directly (admin, no token, no email)
     * @param {AuthenticationApiAdminSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public adminSetPassword(requestParameters: AuthenticationApiAdminSetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).adminSetPassword(requestParameters.adminSetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change password for logged in user
     * @param {AuthenticationApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public changePassword(requestParameters: AuthenticationApiChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).changePassword(requestParameters.changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send login names registered to an e-mail address
     * @param {AuthenticationApiForgotLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public forgotLogin(requestParameters: AuthenticationApiForgotLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).forgotLogin(requestParameters.forgotLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request password reset
     * @param {AuthenticationApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public forgotPassword(requestParameters: AuthenticationApiForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).forgotPassword(requestParameters.forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login user
     * @param {AuthenticationApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(requestParameters: AuthenticationApiLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new user
     * @param {AuthenticationApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public register(requestParameters: AuthenticationApiRegisterRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).register(requestParameters.registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password with token
     * @param {AuthenticationApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPassword(requestParameters: AuthenticationApiResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPassword(requestParameters.resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send an invitation e-mail with the login name and a password setup link (admin)
     * @param {AuthenticationApiSendInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public sendInvitation(requestParameters: AuthenticationApiSendInvitationRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).sendInvitation(requestParameters.adminInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DemoInvitationApi - axios parameter creator
 * @export
 */
export const DemoInvitationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dokončení pozvánky
         * @param {string} token 
         * @param {DemoInvitationAcceptRequest} demoInvitationAcceptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDemoInvitation: async (token: string, demoInvitationAcceptRequest: DemoInvitationAcceptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('acceptDemoInvitation', 'token', token)
            // verify required parameter 'demoInvitationAcceptRequest' is not null or undefined
            assertParamExists('acceptDemoInvitation', 'demoInvitationAcceptRequest', demoInvitationAcceptRequest)
            const localVarPath = `/api/auth/invitation/{token}/accept`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(demoInvitationAcceptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odmítnutí pozvánky
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineDemoInvitation: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('declineDemoInvitation', 'token', token)
            const localVarPath = `/api/auth/invitation/{token}/decline`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Náhled pozvánky — co po příjemci chceme a jestli odkaz ještě platí
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemoInvitation: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getDemoInvitation', 'token', token)
            const localVarPath = `/api/auth/invitation/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poslat nový odkaz na původní adresu
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDemoInvitation: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('resendDemoInvitation', 'token', token)
            const localVarPath = `/api/auth/invitation/{token}/resend`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemoInvitationApi - functional programming interface
 * @export
 */
export const DemoInvitationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemoInvitationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dokončení pozvánky
         * @param {string} token 
         * @param {DemoInvitationAcceptRequest} demoInvitationAcceptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptDemoInvitation(token: string, demoInvitationAcceptRequest: DemoInvitationAcceptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoInvitationAcceptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptDemoInvitation(token, demoInvitationAcceptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DemoInvitationApi.acceptDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odmítnutí pozvánky
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineDemoInvitation(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoInvitationSimpleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineDemoInvitation(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DemoInvitationApi.declineDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Náhled pozvánky — co po příjemci chceme a jestli odkaz ještě platí
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDemoInvitation(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoInvitationPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDemoInvitation(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DemoInvitationApi.getDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poslat nový odkaz na původní adresu
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendDemoInvitation(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoInvitationSimpleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendDemoInvitation(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DemoInvitationApi.resendDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DemoInvitationApi - factory interface
 * @export
 */
export const DemoInvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemoInvitationApiFp(configuration)
    return {
        /**
         * 
         * @summary Dokončení pozvánky
         * @param {DemoInvitationApiAcceptDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDemoInvitation(requestParameters: DemoInvitationApiAcceptDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationAcceptResponse> {
            return localVarFp.acceptDemoInvitation(requestParameters.token, requestParameters.demoInvitationAcceptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odmítnutí pozvánky
         * @param {DemoInvitationApiDeclineDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineDemoInvitation(requestParameters: DemoInvitationApiDeclineDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationSimpleResponse> {
            return localVarFp.declineDemoInvitation(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Náhled pozvánky — co po příjemci chceme a jestli odkaz ještě platí
         * @param {DemoInvitationApiGetDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemoInvitation(requestParameters: DemoInvitationApiGetDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationPreviewResponse> {
            return localVarFp.getDemoInvitation(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poslat nový odkaz na původní adresu
         * @param {DemoInvitationApiResendDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDemoInvitation(requestParameters: DemoInvitationApiResendDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationSimpleResponse> {
            return localVarFp.resendDemoInvitation(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemoInvitationApi - interface
 * @export
 * @interface DemoInvitationApi
 */
export interface DemoInvitationApiInterface {
    /**
     * 
     * @summary Dokončení pozvánky
     * @param {DemoInvitationApiAcceptDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApiInterface
     */
    acceptDemoInvitation(requestParameters: DemoInvitationApiAcceptDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationAcceptResponse>;

    /**
     * 
     * @summary Odmítnutí pozvánky
     * @param {DemoInvitationApiDeclineDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApiInterface
     */
    declineDemoInvitation(requestParameters: DemoInvitationApiDeclineDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationSimpleResponse>;

    /**
     * 
     * @summary Náhled pozvánky — co po příjemci chceme a jestli odkaz ještě platí
     * @param {DemoInvitationApiGetDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApiInterface
     */
    getDemoInvitation(requestParameters: DemoInvitationApiGetDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationPreviewResponse>;

    /**
     * 
     * @summary Poslat nový odkaz na původní adresu
     * @param {DemoInvitationApiResendDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApiInterface
     */
    resendDemoInvitation(requestParameters: DemoInvitationApiResendDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DemoInvitationSimpleResponse>;

}

/**
 * Request parameters for acceptDemoInvitation operation in DemoInvitationApi.
 * @export
 * @interface DemoInvitationApiAcceptDemoInvitationRequest
 */
export interface DemoInvitationApiAcceptDemoInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationApiAcceptDemoInvitation
     */
    readonly token: string

    /**
     * 
     * @type {DemoInvitationAcceptRequest}
     * @memberof DemoInvitationApiAcceptDemoInvitation
     */
    readonly demoInvitationAcceptRequest: DemoInvitationAcceptRequest
}

/**
 * Request parameters for declineDemoInvitation operation in DemoInvitationApi.
 * @export
 * @interface DemoInvitationApiDeclineDemoInvitationRequest
 */
export interface DemoInvitationApiDeclineDemoInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationApiDeclineDemoInvitation
     */
    readonly token: string
}

/**
 * Request parameters for getDemoInvitation operation in DemoInvitationApi.
 * @export
 * @interface DemoInvitationApiGetDemoInvitationRequest
 */
export interface DemoInvitationApiGetDemoInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationApiGetDemoInvitation
     */
    readonly token: string
}

/**
 * Request parameters for resendDemoInvitation operation in DemoInvitationApi.
 * @export
 * @interface DemoInvitationApiResendDemoInvitationRequest
 */
export interface DemoInvitationApiResendDemoInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof DemoInvitationApiResendDemoInvitation
     */
    readonly token: string
}

/**
 * DemoInvitationApi - object-oriented interface
 * @export
 * @class DemoInvitationApi
 * @extends {BaseAPI}
 */
export class DemoInvitationApi extends BaseAPI implements DemoInvitationApiInterface {
    /**
     * 
     * @summary Dokončení pozvánky
     * @param {DemoInvitationApiAcceptDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApi
     */
    public acceptDemoInvitation(requestParameters: DemoInvitationApiAcceptDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return DemoInvitationApiFp(this.configuration).acceptDemoInvitation(requestParameters.token, requestParameters.demoInvitationAcceptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odmítnutí pozvánky
     * @param {DemoInvitationApiDeclineDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApi
     */
    public declineDemoInvitation(requestParameters: DemoInvitationApiDeclineDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return DemoInvitationApiFp(this.configuration).declineDemoInvitation(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Náhled pozvánky — co po příjemci chceme a jestli odkaz ještě platí
     * @param {DemoInvitationApiGetDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApi
     */
    public getDemoInvitation(requestParameters: DemoInvitationApiGetDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return DemoInvitationApiFp(this.configuration).getDemoInvitation(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poslat nový odkaz na původní adresu
     * @param {DemoInvitationApiResendDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoInvitationApi
     */
    public resendDemoInvitation(requestParameters: DemoInvitationApiResendDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return DemoInvitationApiFp(this.configuration).resendDemoInvitation(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthControllerApi - axios parameter creator
 * @export
 */
export const HealthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthControllerApi - functional programming interface
 * @export
 */
export const HealthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthControllerApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthControllerApi - factory interface
 * @export
 */
export const HealthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthControllerApi - interface
 * @export
 * @interface HealthControllerApi
 */
export interface HealthControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthControllerApiInterface
     */
    health(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

}

/**
 * HealthControllerApi - object-oriented interface
 * @export
 * @class HealthControllerApi
 * @extends {BaseAPI}
 */
export class HealthControllerApi extends BaseAPI implements HealthControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthControllerApi
     */
    public health(options?: RawAxiosRequestConfig) {
        return HealthControllerApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImpersonationApi - axios parameter creator
 * @export
 */
export const ImpersonationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvori jednorazovy odkaz pro prihlaseni jako zadany uzivatel
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminImpersonationLink: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createAdminImpersonationLink', 'userId', userId)
            const localVarPath = `/api/admin/impersonate/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spotrebuje impersonacni odkaz a prihlasi prohlizec jako cilovy uzivatel
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImpersonationSession: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('startImpersonationSession', 'token', token)
            const localVarPath = `/api/auth/impersonate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImpersonationApi - functional programming interface
 * @export
 */
export const ImpersonationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImpersonationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvori jednorazovy odkaz pro prihlaseni jako zadany uzivatel
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminImpersonationLink(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonationLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminImpersonationLink(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpersonationApi.createAdminImpersonationLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spotrebuje impersonacni odkaz a prihlasi prohlizec jako cilovy uzivatel
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImpersonationSession(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImpersonationSession(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpersonationApi.startImpersonationSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImpersonationApi - factory interface
 * @export
 */
export const ImpersonationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImpersonationApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvori jednorazovy odkaz pro prihlaseni jako zadany uzivatel
         * @param {ImpersonationApiCreateAdminImpersonationLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminImpersonationLink(requestParameters: ImpersonationApiCreateAdminImpersonationLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationLinkResponse> {
            return localVarFp.createAdminImpersonationLink(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spotrebuje impersonacni odkaz a prihlasi prohlizec jako cilovy uzivatel
         * @param {ImpersonationApiStartImpersonationSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImpersonationSession(requestParameters: ImpersonationApiStartImpersonationSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startImpersonationSession(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImpersonationApi - interface
 * @export
 * @interface ImpersonationApi
 */
export interface ImpersonationApiInterface {
    /**
     * 
     * @summary Vytvori jednorazovy odkaz pro prihlaseni jako zadany uzivatel
     * @param {ImpersonationApiCreateAdminImpersonationLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationApiInterface
     */
    createAdminImpersonationLink(requestParameters: ImpersonationApiCreateAdminImpersonationLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationLinkResponse>;

    /**
     * 
     * @summary Spotrebuje impersonacni odkaz a prihlasi prohlizec jako cilovy uzivatel
     * @param {ImpersonationApiStartImpersonationSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationApiInterface
     */
    startImpersonationSession(requestParameters: ImpersonationApiStartImpersonationSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createAdminImpersonationLink operation in ImpersonationApi.
 * @export
 * @interface ImpersonationApiCreateAdminImpersonationLinkRequest
 */
export interface ImpersonationApiCreateAdminImpersonationLinkRequest {
    /**
     * 
     * @type {number}
     * @memberof ImpersonationApiCreateAdminImpersonationLink
     */
    readonly userId: number
}

/**
 * Request parameters for startImpersonationSession operation in ImpersonationApi.
 * @export
 * @interface ImpersonationApiStartImpersonationSessionRequest
 */
export interface ImpersonationApiStartImpersonationSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof ImpersonationApiStartImpersonationSession
     */
    readonly token: string
}

/**
 * ImpersonationApi - object-oriented interface
 * @export
 * @class ImpersonationApi
 * @extends {BaseAPI}
 */
export class ImpersonationApi extends BaseAPI implements ImpersonationApiInterface {
    /**
     * 
     * @summary Vytvori jednorazovy odkaz pro prihlaseni jako zadany uzivatel
     * @param {ImpersonationApiCreateAdminImpersonationLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationApi
     */
    public createAdminImpersonationLink(requestParameters: ImpersonationApiCreateAdminImpersonationLinkRequest, options?: RawAxiosRequestConfig) {
        return ImpersonationApiFp(this.configuration).createAdminImpersonationLink(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spotrebuje impersonacni odkaz a prihlasi prohlizec jako cilovy uzivatel
     * @param {ImpersonationApiStartImpersonationSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationApi
     */
    public startImpersonationSession(requestParameters: ImpersonationApiStartImpersonationSessionRequest, options?: RawAxiosRequestConfig) {
        return ImpersonationApiFp(this.configuration).startImpersonationSession(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



